import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/workRequestIds${`?fieldReportIds=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/workRequestIds`;

export const URL = (fieldReportIds: number[]): RouteDefinition => `${baseRoute}/workRequestIds?fieldReportIds=${encodeURIComponent((JSON.stringify(fieldReportIds)))}`;
